export default __webpack_public_path__ + "static/media/ablation.b29bdf12.pdf";